module.exports = __webpack_public_path__ + "static/img/illustration.b4c3732c.png";